var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPaperclip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7A7ACAA4-2484-4277-AA17-2C47C661A08A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hilbi-WebApp-Desktop-Chat_Detail",
    transform: "translate(-995.000000, -968.000000)",
    fill: "#333D6C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(193.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-Textfield",
    transform: "translate(0.000000, 639.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(670.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(78.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Emojis",
    transform: "translate(46.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paperclip",
    transform: "translate(8.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.576802,6.95850052 L7.27310757,13.341738 C5.99055616,14.6404733 3.9118448,14.6404733 2.62929339,13.341738 C1.34579109,12.0420399 1.34579109,9.93409279 2.62929339,8.63439462 L8.93298779,2.25115713 C9.67949681,1.49522832 10.8891117,1.49522832 11.6356207,2.25115716 C12.3830807,3.00804888 12.3830807,4.23593283 11.6356208,4.99282457 L5.32538726,11.375738 C5.11460045,11.5891845 4.77408193,11.5891845 4.56361529,11.3760621 C4.35219775,11.1619768 4.35219775,10.8141559 4.56361529,10.6000706 L10.3868119,4.71033969 C10.712104,4.38133087 10.7118693,3.84813936 10.3862876,3.51942313 C10.060706,3.19070689 9.53306855,3.19094408 9.20777644,3.5199529 L3.38423287,9.41003494 C2.52321866,10.2819136 2.52321866,11.694219 3.38388589,12.5657466 C4.24550402,13.438237 5.64317835,13.438237 6.50479648,12.5657466 L12.81503,6.1828331 C14.2120598,4.76817506 14.2120597,2.47580663 12.8153501,1.06147266 C11.4176896,-0.353824205 9.15091892,-0.353824222 7.75325841,1.06147262 L1.449564,7.44471013 C-0.483188,9.40185054 -0.483188,12.5742821 1.449564,14.5314225 C3.3832669,16.4895258 6.51913407,16.4895258 8.45283696,14.5314225 L14.7565314,8.14818502 C15.0816316,7.81898255 15.0810859,7.28579128 14.7553126,6.95726897 C14.4295394,6.62874667 13.9019022,6.62929806 13.576802,6.95850052 Z",
    id: "Path"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperclip);
export default __webpack_public_path__ + "static/media/icon-paperclip.59e4245e5727eeb80dbb6569242a64c1.svg";
export { ForwardRef as ReactComponent };